const roleCardStyles = {
  // The header matches the profile row below (63px + 1px border); only duties add height.
  card: {
    padding: '0 16px',
    background: '#F8F9FA',
    borderTop: '1px solid #E0E0E0',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    height: 63,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  avatar: {
    width: 36,
    height: 36,
    flexShrink: 0,
    boxSizing: 'border-box',
    borderRadius: '50%',
    border: '1px solid #E8A29C',
    background: '#FDECEA',
    color: '#B23B35',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarIcon: {
    fontSize: 20,
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  role: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    fontSize: 14,
    fontWeight: 700,
    color: '#202124',
  },
  helpButton: {
    width: 28,
    height: 28,
    margin: '-6px 0',
    padding: 0,
    border: 0,
    borderRadius: '50%',
    background: 'transparent',
    color: '#5F6368',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      background: '#E8EAED',
    },
  },
  helpIcon: {
    fontSize: 16,
  },
  org: {
    fontSize: 11,
    color: '#5F6368',
  },
  popover: {
    width: 220,
    boxSizing: 'border-box',
    padding: '12px 14px',
    border: '1px solid #E0E0E0',
    borderRadius: 6,
    boxShadow: '0 6px 20px rgba(0,0,0,0.14)',
  },
  help: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    gap: 8,
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.4,
    textDecoration: 'none',
    color: '#B23B35',
    '&:hover': {
      color: '#8E2C27',
    },
  },
  helpLinkIcon: {
    fontSize: 14,
    flexShrink: 0,
    marginTop: 2,
  },
  description: {
    padding: '0 0 12px 48px',
    fontSize: 13,
    color: '#5F6368',
  },
  // Duty icons share the role icon's column, so the list reads as part of the role.
  duties: {
    paddingBottom: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  duty: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    height: 26,
    fontSize: 13,
    color: '#3C4043',
  },
  dutyIconColumn: {
    width: 36,
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    color: '#B23B35',
  },
  dutyIcon: {
    fontSize: 15,
  },
}

export default roleCardStyles
